import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { HeaderLayoutComponent } from './header-layout.component'

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [HeaderLayoutComponent],
  exports: [HeaderLayoutComponent]
})
export class HeaderLayoutModule {}
